export default "__VITE_ASSET__bb18cd8a__"